import React from "react";
import "./styles.css";

import logo_topo from "../../assets/logo_topo.png";
import CtaWpp from "../../components/CTAWpp";

const Menu = () => {
  return (
    <nav id="menu">
      <section className="container">
        <figure className="left">
          <img src={logo_topo} alt="Logo" />
        </figure>

        <article className="right">
          <CtaWpp />
        </article>
      </section>
    </nav>
  );
};

export default Menu;
